import { useContext } from "react";
import {
  AlertContext,
  EventsContext,
  PowerContext,
  RoleContext,
} from "../contexts/context";

export const useAlertContext = () => {
  const alertContext = useContext(AlertContext);
  return alertContext;
};

export const useEventsContext = () => {
  const eventsContext = useContext(EventsContext);
  return eventsContext;
};

export const usePowerContext = () => {
  const powerContext = useContext(PowerContext);
  return powerContext;
};

export const useRoleContext = () => {
  const roleContext = useContext(RoleContext);
  return roleContext;
};
